import React, { useCallback, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";
import ContentBrowser from "./browse/ContentBrowser";
import withAuthorization from "../../auth/withAuthorization";
import { useEditScreenClose } from "../use-editScreenClose";
import { Route, useLocation, useRouteMatch } from "react-router-dom";
import {
  LOCAL_STORAGE_CONTENT_SEARCH_PREFERENCES_KEY,
  useSearch,
} from "../searchServices";
import { lensProp, mergeDeepRight, set } from "ramda";
import ContentEdit from "./edit/ContentEdit";
import { useLocalStorage } from "../../common/use-localStorage";
import { organizeRoles, useIsIapReviewer } from "../../auth/authUtils";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  panel: {
    display: "flex",
    flexDirection: "column",
    height: "95%",
    padding: "0",
    border: "3px solid white",
    background: "white",
    borderRadius: "20px",
  },
}));

export const initialStatus = {
  name: "status",
  queryParam: "status",
  terms: [
    { code: "(-status:* AND *:*)" }, // NULL status
    { code: "APPROVED" },
    { code: "PENDING" },
    { code: "REJECTED" },
    { code: "TAKEDOWN" },
  ],
};

const initialState = (initialState = {}, initialSearch) => {
  return set(
    lensProp("appliedQuery"),
    initialSearch,
    mergeDeepRight(
      {
        appliedQuery: [],
        appliedFacets: [
          {
            name: "type",
            queryParam: "_type",
            terms: [
              {
                code: "CONTENT",
              },
            ],
          },
          initialStatus,
        ],
        orderBy: "",
        orderDirection: "",
        page: 0,
        limit: 10,
      },
      initialState,
    ),
  );
};

const initialSearchState = {
  noFacets: true,
};

const initialFacetState = {
  noFacets: false,
  facetsOnly: true,
};

// TODO: refactor edit dialog routing
// Setting withAuthorization to false to not show unauthorized screen because
// unauthorized screen flashes when navigating to and away from edit screen for non-Admin users
const AuthorizedRoute = withAuthorization(Route, false);

const ContentView = () => {
  const classes = useStyles();
  const { path, isExact } = useRouteMatch();
  const history = useHistory();
  const location = useLocation();
  const isIapReviewer = useIsIapReviewer();

  useEffect(() => {
    // send IAP reviewers back to Workbench
    if (isExact && isIapReviewer) {
      history.replace("/creator/organize?view=review,pending");
    }
  }, [history, isExact, isIapReviewer]);

  const [searchPreferences, setSearchPreferences] = useLocalStorage(
    LOCAL_STORAGE_CONTENT_SEARCH_PREFERENCES_KEY,
    {
      titleOnly: false,
    },
  );

  const initialSearchValue =
    location?.state?.search?.content?.appliedQuery ?? [];

  const [searchState, setSearchState] = useState(
    initialState(
      { ...initialSearchState, ...searchPreferences },
      initialSearchValue,
    ),
  );
  const [facetState, setFacetState] = useState(
    initialState(
      { ...initialFacetState, ...searchPreferences },
      initialSearchValue,
    ),
  );

  const searchResults = useSearch(searchState);
  const facetResults = useSearch(facetState);

  const handleEditScreenClose = useEditScreenClose("/content");

  const handleSave = useCallback(() => {
    handleEditScreenClose();
    searchResults.refetch();
    console.log("location from content view: ", location);
  }, [searchResults, handleEditScreenClose, location]);

  const handleCancel = useCallback(() => {
    handleEditScreenClose();
  }, [handleEditScreenClose]);

  return (
    <Container
      id="content-view"
      disableGutters
      maxWidth={false}
      classes={{ root: classes.panel }}
    >
      <AuthorizedRoute exact path={`${path}`} roles={["ROLE_ADMIN"]}>
        <ContentBrowser
          searchState={searchState}
          facetState={facetState}
          onSearchStateChange={state => setSearchState(state)}
          onFacetStateChange={state => setFacetState(state)}
          searchResults={searchResults}
          facetResults={facetResults}
          onSaveSuccess={handleSave}
          setSearchPreferences={setSearchPreferences}
        />
      </AuthorizedRoute>

      <AuthorizedRoute path={`${path}/:id`} roles={organizeRoles}>
        <ContentEdit onCancel={handleCancel} onSaveSuccess={handleSave} />
      </AuthorizedRoute>
    </Container>
  );
};

export default ContentView;
